var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3553 3.14258H12.3076V5.43796H14.6392V7.00027H12.3076V8.52719H14.6153V10.0657H12.3076V11.6041H14.6153V13.1426H12.3076V14.681H14.6153V16.2195H12.3076V18.5272H19.3553C19.7099 18.5272 19.9999 18.2264 19.9999 17.858V3.81181C19.9999 3.44335 19.7099 3.14258 19.3553 3.14258ZM18.4615 16.2195H15.3845V14.681H18.4615V16.2195ZM18.4615 13.1426H15.3845V11.6041H18.4615V13.1426ZM18.4615 10.0657H15.3845V8.52719H18.4615V10.0657ZM18.4615 6.98873H15.3845V5.45027H18.4615V6.98873Z",
    fill: "#3DA967"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.05629V18.6124L11.5385 20.834V0.833984L0 3.05629ZM7.29846 14.7417L5.95615 12.204C5.90538 12.1094 5.85308 11.9355 5.79846 11.6824H5.77769C5.75231 11.8017 5.69231 11.9832 5.59769 12.2263L4.25077 14.7417H2.15923L4.64231 10.8463L2.37077 6.95014H4.50615L5.62 9.28629C5.70692 9.47091 5.78462 9.69014 5.85385 9.94322H5.87538C5.91923 9.79091 6.00077 9.56475 6.12 9.26398L7.35846 6.94937H9.31385L6.97769 10.8124L9.37923 14.7409L7.29846 14.7417Z",
    fill: "#3DA967"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/xlsIcon.352e46b17fe43febca41564cf2695feb.svg";
export { ForwardRef as ReactComponent };